import { render } from "./headset.svg?vue&type=template&id=486e703c?inline"
const script = {}
script.render = render

export default script